import { getRoofTypes } from 'common/api/v1/core';

import {
    FETCH_ROOF_TYPES,
    FETCH_ROOF_TYPES_FAILURE,
    FETCH_ROOF_TYPES_SUCCESS,
} from '../actionTypes';
import { createProposalModalActions } from '../reducer';

export default () => (dispatch) => {
    dispatch(createProposalModalActions[FETCH_ROOF_TYPES]());

    getRoofTypes()
        .then((response) =>
            dispatch(
                createProposalModalActions[FETCH_ROOF_TYPES_SUCCESS](
                    response?.data?.data,
                ),
            ),
        )
        .catch((error) =>
            dispatch(
                createProposalModalActions[FETCH_ROOF_TYPES_FAILURE](error),
            ),
        );
};
